import React, { useEffect, useState } from 'react';
import { useSingleEffect } from 'react-haiku';
import { useParams } from 'react-router-dom';
import { useRequest } from 'hooks';

import { DOCUMENT_TYPES } from 'utils/Constants';

import Editor from 'components/Editor';
import { Title } from 'components/Misc/Typography';
import { Form, Input, Button, Select, Checkbox } from 'components/Misc/Form';

import { useDocumentProfileStore } from 'store/document/useDocumentProfileStore';

const Content = ({ tab, setTab }) => {
	// Cache current document's id
	const { id } = useParams();

	// Update selected tab on mount
	useSingleEffect(() => setTab(tab));

	// Use document's profile store	
	const [original, onUpdate] = useDocumentProfileStore(state => [
		state.document,
		state.onUpdate
	]);

	// Store document's data
	const [document, setDocument] = useState({
		title: '',
		content: '',
		teacher: false,
		student: false,
		parent: false,
		status: '',
		type: ''
	});

	// Store request
	const [[progress], request] = useRequest('put', `documents/${id}`);

	// Handle input value change
	const onChange = ({ name, value }) => {
		setDocument(prev => ({
			...prev,
			[name]: value
		}));
	};

	// Handles form's onSubmit event
	// @event: object | onSubmit event
	const onSubmit = async event => {
		event.preventDefault();

		// Do not allow update if in progress or not editable
		if (progress) return;

		// Try to update document's data
		const [success, error] = await request(document);

		// Update document's data
		if (success) return onUpdate(document);

		// TODO: Think of a better way of handling errors
		if (error) console.log(error);
	};

	// Initialize document's content
	useEffect(() => {
		if (original) setDocument(prev => ({
			...prev,
			title: original.title,
			content: original.content,
			teacher: original.teacher,
			student: original.student,
			parent: original.parent,
			status: original.status,
			type: original.type,
		}));
	}, [original]);

	return (
		<Form
			onSubmit={onSubmit}
			className="mt-4 p-4 space-y-4 bg-white dark:bg-neutral-800 rounded-lg transition-colors"
		>
			<Title title="Pamatinformācija" className="text-xl" />

			<Input
				type="text"
				name="title"
				placeholder=" "
				label="Virsraksts"
				value={document.title}
				onChange={onChange}
			/>

			<div className="grid md:grid-cols-2 gap-4">
				<Select
					name="type"
					label="Kategorija"
					placeholder=" "
					value={document.type}
					onChange={onChange}
					options={DOCUMENT_TYPES.map(type => ({
						value: type.value, name: type.text
					}))}
				/>
			</div>
			
			<Editor
				type="large"
				label="Dokuments"
				name="content"
				path="documents"
				folder={original.slug}
				value={document.content}
				onChange={onChange}
			/>

			<Title title="Pieejamība" className="text-xl" />

			{/* Document's accessability */}
			<div className="grid grid-cols-2 gap-4">
				<Select
					name="status"
					label="Statuss"
					placeholder=" "
					value={document.status}
					onChange={onChange}
					options={[
						{ value: 'visible', name: 'Redzams' },
						{ value: 'hidden', name: 'Slēpts' }
					]}
				/>
			</div>

			<Title title="Grupas" className="text-xl" />

			{/* Document's groups */}
			<div className="flex space-x-4">
				<Checkbox
					small
					inline
					name="teacher"
					label="Pedagogi"
					value={document.teacher}
					onChange={onChange}
				/>

				<Checkbox
					small
					inline
					name="student"
					label="Studenti"
					value={document.student}
					onChange={onChange}
				/>

				<Checkbox
					small
					inline
					name="parent"
					label="Vecāki"
					value={document.parent}
					onChange={onChange}
				/>
			</div>

			<div className="flex justify-end">
				<Button
					submit
					icon="done"
					value="Saglabāt"
					theme="success"
					progress={progress}
				/>
			</div>
		</Form>
	);
};

export default Content;